import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { useScaleX } from '../1d/utilities/scale';
import { useGlobal } from '../context/GlobalContext';
import SVGResizer from './resizer/SVGResizer';
export function ResizerWithScale(props) {
    const { from, to, onEnd, disabled, children } = props;
    const { viewerRef } = useGlobal();
    const scaleX = useScaleX();
    const x2 = scaleX()(from);
    const x1 = scaleX()(to);
    const [position, setPosition] = useState({ x1, x2 });
    const startPositionRef = useRef();
    useEffect(() => {
        const x2 = scaleX()(from);
        const x1 = scaleX()(to);
        setPosition({ x1, x2 });
    }, [from, scaleX, to]);
    function handleMove(p) {
        if (p.x2 >= p.x1) {
            setPosition(p);
        }
    }
    function handleEndMove(p) {
        if (p.x2 >= p.x1) {
            onEnd?.(p);
        }
        else if (startPositionRef.current) {
            setPosition({ ...startPositionRef.current });
        }
    }
    function handleStartResize(p) {
        startPositionRef.current = p;
    }
    return (_jsx(SVGResizer, { position: position, onStart: handleStartResize, onEnd: handleEndMove, parentElement: viewerRef, disabled: disabled, onMove: handleMove, children: children }));
}
